import { Link, useLocation, useNavigate } from "react-router-dom";
import { FaHome, FaHistory, FaSave, FaYoutube } from "react-icons/fa";
import FilterPost from "./filterPost";
// import SupportUs from "../../post/modals/SupportUsModal";
// import useSupportUsModal from "../../post/hooks/useSupportUs";
import { useTranslation } from "react-i18next";
import useSidebar from "../../hooks/post/useSidebar";
import { FaHandHoldingHeart, FaPlus } from "react-icons/fa"; 
import { MdGroups2 } from "react-icons/md";
import { MdOutlineCalculate } from "react-icons/md";
import { getToken } from '../../storage/LocalStorageService.js';
import LanguageSelector from '../../hooks/main/language-selector';
import Switcher from "../../pages/mainPages/darkmode.js";
import useViewYTVideo from "../../hooks/main/useViewDocumentModal.js";
import useCreateUpdatePost from "../../hooks/post/useCreateUpdatePost.js";


const Sidebar = () => {
  const { isOpen: isSidebarOpen, close: closeSidebar } = useSidebar();
  const location = useLocation();
  const navigate = useNavigate();
  const { access_token } = getToken();
  const uViewYTVideo = useViewYTVideo()
  const { t } = useTranslation('common')
  const sidebar = t("sidebar")
  const filter = t("filter")
  const navbar = t('navbar')

  const { openCreate } = useCreateUpdatePost();
  
  const handleCreatePostClick = (openCreate) => {
    if (access_token) {
      openCreate();
    } else {
      navigate('/auth/login');
    }
  };

  const isActive = (path) => {
    return location.pathname === path;
  };

  const handleTabClick = (callback) => {
    if (callback) callback();
    closeSidebar();
  };

  const handleSimpleTabClick = () => {
    closeSidebar();
  };

  return (
    <div className={`fixed top-0 h-screen w-full dark:bg-gray-700 overflow-y-auto z-40 transform bg-white ${isSidebarOpen ? "translate-x-0" : "-translate-x-full"
    } transition-transform duration-300 ease-in-out md:translate-x-0 md:w-64`}>

      <div className="pt-12 h-full flex flex-col">
        {/* Main Navigation */}
        <div className="flex-1">
          <ul className="list-none mt-15 p-2 space-y-1">
            <li>
              <Link to="/posts" onClick={handleSimpleTabClick}>
                <div
                  className={`flex items-center hover:bg-slate-200 dark:hover:bg-slate-800 rounded-lg p-2 dark:text-white transition-colors ${
                    isActive("/posts") ? "bg-slate-200 dark:bg-slate-800" : ""
                  }`}
                >
                  <FaHome className="w-5 h-5" />
                  <p className="px-5 text-sm font-medium">{sidebar.home}</p>
                </div>
              </Link>
            </li>
            
            <li>
              <Link to="/saves" onClick={handleSimpleTabClick}>
                <div
                  className={`flex items-center hover:bg-slate-200 dark:hover:bg-slate-800 rounded-lg p-2 dark:text-white transition-colors ${
                    isActive("/saves") ? "bg-slate-200 dark:bg-slate-800" : ""
                  }`}
                >
                  <FaSave className="w-5 h-5" />
                  <p className="px-5 text-sm font-medium">{sidebar.saved_posts}</p>
                </div>
              </Link>
            </li>

            <li>
              <Link to="/history" onClick={handleSimpleTabClick}>
                <div
                  className={`flex items-center hover:bg-slate-200 dark:hover:bg-slate-800 rounded-lg p-2 dark:text-white transition-colors ${
                    isActive("/history") ? "bg-slate-200 dark:bg-slate-800" : ""
                  }`}
                >
                  <FaHistory className="w-5 h-5" />
                  <p className="px-5 text-sm font-medium">{sidebar.history}</p>
                </div>
              </Link>
            </li>

            <li>
              <FilterPost className="w-full" isFilterActive={isActive("/filter")} translation={filter} Navtranslation={navbar} handleTabClick={handleTabClick} />
            </li>
          </ul>
        </div>

        {/* Divider */}
        <div className="px-4 py-2">
          <hr className="border-gray-300 dark:border-gray-600" />
        </div>
                  
        <ul className="list-none p-2 space-y-2">
          <li>
            <button
              onClick={() => {
                handleSimpleTabClick();
                uViewYTVideo.open("https://www.youtube.com/embed/fwE7J0SPpEw", "How to create post");;
              }}
              className="flex items-center w-full hover:bg-red-100 dark:hover:bg-red-900 rounded-lg gap-3 p-1 transition-colors border-red border hover:bg-rose-100 hover:dark:bg-rose-50"
            >
              <FaYoutube className="w-6 h-6 text-red" />
              <span className="px-1 text-sm text-red-700 dark:text-red-300 text-rose-400 font-bold">
                Watch how to create post
              </span>
            </button>
          </li>
        </ul>


        {/* Divider */}
        <div className="px-4 py-2">
          <hr className="border-gray-300 dark:border-gray-600" />
        </div>

                  
        <ul className="list-none p-2 space-y-2">
          <li>
            <Link
              to="/who-to-pay-zakat"
              onClick={handleSimpleTabClick}
              className={`flex items-center hover:bg-slate-200 dark:hover:bg-slate-800 rounded-lg gap-1 p-2 dark:text-white transition-colors ${
                isActive("/who-to-pay-zakat") ? "bg-slate-200 dark:bg-slate-800" : ""
              }`}
            >
              <FaHandHoldingHeart className="w-5 h-5 text-red-500" />
              <span className="px-4 text-sm font-medium">{sidebar.whomZakat}</span>
            </Link>
          </li>

          <li>
            <Link
              to="/calculate-zakat"
              onClick={handleSimpleTabClick}
              className={`flex items-center hover:bg-slate-200 dark:hover:bg-slate-800 rounded-lg gap-1 p-2 dark:text-white transition-colors ${
                isActive("/calculate-zakat") ? "bg-slate-200 dark:bg-slate-800" : ""
              }`}
            >
              <MdOutlineCalculate className="w-5 h-5 text-red-500" />
              <span className="px-4 text-sm font-medium">{sidebar.calculate_zakat}</span>
            </Link>
          </li>


        {/* Support Us - Mobile Only */}
        {/* <div
          onClick={() => handleTabClick(() => uSupportModal.open())}
          className="flex items-center hover:bg-slate-200 dark:hover:bg-slate-800 rounded-lg p-2 dark:text-white hover:cursor-pointer transition-colors"
        >
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-5 h-5">
            <path strokeLinecap="round" strokeLinejoin="round" d="M2.25 18.75a60.07 60.07 0 0 1 15.797 2.101c.727.198 1.453-.342 1.453-1.096V18.75M3.75 4.5v.75A.75.75 0 0 1 3 6h-.75m0 0v-.375c0-.621.504-1.125 1.125-1.125H20.25M2.25 6v9m18-10.5v.75c0 .414.336.75.75.75h.75m-1.5-1.5h.375c.621 0 1.125.504 1.125 1.125v9.75c0 .621-.504 1.125-1.125 1.125h-.375m1.5-1.5H21a.75.75 0 0 0-.75.75v.75m0 0H3.75m0 0h-.375a1.125 1.125 0 0 1-1.125-1.125V15m1.5 1.5v-.75A.75.75 0 0 0 3 15h-.75M15 10.5a3 3 0 1 1-6 0 3 3 0 0 1 6 0Zm3 0h.008v.008H18V10.5Zm-12 0h.008v.008H6V10.5Z" />
          </svg>
          <p className="px-4 text-sm font-medium">{navbar.support_us}</p>
          <SupportUs />
        </div> */}

        <li>
          <Link
            to="/donor-community"
            onClick={handleSimpleTabClick}
            className={`flex items-center hover:bg-slate-200 dark:hover:bg-slate-800 rounded-lg gap-4 p-2 dark:text-white transition-colors ${
              isActive("/donor-community") ? "bg-slate-200 dark:bg-slate-800" : ""
            }`}
          >
            <MdGroups2 className="w-6 h-6" />
            <span className="">{navbar.dc}</span>
          </Link>
        </li>

        {/* <li>
          <Link
            to="/"
            onClick={handleSimpleTabClick}
            className={`flex items-center hover:bg-slate-200 dark:hover:bg-slate-800 rounded-lg gap-1 p-2 dark:text-white transition-colors ${
              isActive("/") ? "bg-slate-200 dark:bg-slate-800" : ""
            }`}
          >
            <HiInformationCircle className="w-5 h-5 text-red-500" />
            <span className="px-4 text-sm font-medium">{sidebar.aboutAddZakat}</span>
          </Link>
        </li> */}

        <li>
          <button 
          className="relative flex items-center group rounded-xl gap-4 p-3 px-5 bg-gradient-to-r border border-blue-300 dark:border-blue-500/60 text-white dark:text-white transition-all duration-300 ease-out shadow-lg shadow-blue-200/50 dark:shadow-blue-900/30 transform -translate-y-0.5 focus:outline-none focus:ring-2 focus:ring-blue-400 focus:ring-opacity-75 active:translate-y-0 active:scale-[0.98] w-full"
          onClick={() => handleTabClick(() => handleCreatePostClick(openCreate))}
          tabIndex={0}
          >
            {/* Animated background on hover */}
            <span className="absolute inset-0 w-full h-full rounded-xl overflow-hidden">
              <span className="absolute inset-0 bg-gradient-to-r from-blue-500 to-indigo-600 opacity-100 transition-opacity duration-300 -z-10"></span>
            </span>
            
            {/* Animated plus icon */}
            <span className="relative z-10">
              <FaPlus className="w-5 h-5 transition-transform duration-300 group-hover:rotate-90 group-active:rotate-180" />
            </span>
            
            {/* Text with animated underline */}
            <span className="relative z-10 font-medium">
              {navbar.create_post}
              <span className="absolute left-0 -bottom-1 w-0 h-0.5 bg-white group-hover:w-full transition-all duration-300"></span>
            </span>
            
            {/* Ripple effect container */}
            <span className="absolute inset-0 overflow-hidden rounded-xl -z-10">
              <span className="ripple absolute bg-white/30 rounded-full scale-0 origin-center animate-ripple"></span>
            </span>
          </button>
        </li>
        
        <hr />
        <li  dir="ltr" className="flex gap-3 justify-center mb-2">
            <Switcher/> 
            <LanguageSelector />
        </li>
        </ul>


      </div>
    </div>
  );
};

export default Sidebar
